export default "__VITE_PUBLIC_ASSET__004e4d11__"